const scrollContainer = document.querySelector('.iww-breadcrumb-scroll');
if (scrollContainer !== null) {
    const scrollContainerWidth = scrollContainer.offsetWidth;
    let isDown = false;
    let startX;
    let scrollLeft;
    let maxScrollAmt = scrollContainer.scrollWidth - scrollContainerWidth;

    scrollContainer.addEventListener('mousedown', (e) => {
        isDown = true;
        scrollContainer.classList.add('cursor-grabbing');
        startX = e.pageX - scrollContainer.offsetLeft;
        scrollLeft = scrollContainer.scrollLeft;
    });
    scrollContainer.addEventListener('mouseleave', () => {
        isDown = false;
        scrollContainer.classList.remove('cursor-grabbing');
    });
    scrollContainer.addEventListener('mouseup', () => {
        isDown = false;
        scrollContainer.classList.remove('cursor-grabbing');
    });
    scrollContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return; //stop the function from running
        e.preventDefault();
        const x = e.pageX - scrollContainer.offsetLeft;
        const walk = x - startX;
        scrollContainer.scrollLeft = scrollLeft - walk;

        if (scrollContainer.scrollLeft > 0) {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("before:block");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("before:hidden");
        } else {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("before:hidden");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("before:block");
        }


        if (scrollContainer.scrollLeft <= maxScrollAmt) {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("after:block");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("after:hidden");
        } else {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("after:hidden");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("after:block");
        }
    });

    window.addEventListener("resize", function () {

        if (scrollContainer.scrollLeft > 0) {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("before:block");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("before:hidden");
        } else {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("before:hidden");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("before:block");
        }

        if (scrollContainer.scrollLeft <= maxScrollAmt) {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("after:block");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("after:hidden");
        } else {
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.add("after:hidden");
            scrollContainer.closest(".iww-breadcrumb-wrapper").classList.remove("after:block");
        }

    });
}